module.exports = __webpack_public_path__ + "img/premiation-7-cruzeiro-nacional.503b9d27.png";